import { MaxWinConfig } from "@westpierstudio/core-module-oryx/components/ui/slot-game-ui/menu/paytable/paytableContentFactory/AbstractPaytableContentFactory";
import { RTPVariant } from "servertypes/gameevents/OpenGame";

type Rtp = number;

type RtpConfig = Record<Rtp, MaxWinConfig>;
type MaxWinConfigsByRTPVariant = Record<RTPVariant, RtpConfig | undefined>

export const MaxWinConfigsByRTPVariant: MaxWinConfigsByRTPVariant = {
    "spread0": {
        88: {
            minRatio: 1,
            maxRatio: 1000000000
          }
    },
    "spread1": {
        88: {
            minRatio: 1,
            maxRatio: 1000000000
          }
    }
};
